/**
 * Authentication error class.
 */
export class AuthError extends Error {}
